import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '@/store';
Vue.use(VueRouter);

const VueRouterPush = VueRouter.prototype.push 
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

const pages = [
	{
		path: '/select',
		name: 'SelectionAssistant',
		component: () => import('@/views/pages/selectionAssistant/index.vue')
	},
	{   // 发文详情-列表
		path: '/list',
		name: 'List',
		component: () => import('@/views/pages/selectionAssistant/pubDetail/list.vue')
	},
	{   // 期刊大全
		path: '/allJournals',
		name: 'AllJournals',
		component: () => import('@/views/pages/selectionAssistant/journals/allJournals.vue')
	},
]

const router = new VueRouter({
	routes: [{
			path: '/',
			redirect: '/index'
		},
		{
			path: '/index',
			name: 'Index',
			redirect: '/select',
			component: () => import('@/views/index.vue'),
			children: [
				...pages
			]
		},
		{
			path: '/noPermission',
			name: 'noPermission',
			component: () => import('@/views/noPermission.vue'),
		},
		{
			path: '/404',
			component: () => import('@/views/404.vue')
		},
		{
			path: '*',
			redirect: '/404'
		}
	]
})

// 路由跳转前
router.beforeEach((to, from, next) => {
	// 可用于拦截导航并执行一些操作，例如验证用户身份、权限控制等。
	if(to.meta.title) {
		document.title = to.meta.title
	} else {
		document.title = Store.state.itemName
	}
	next()
})

// 路由跳转后
router.afterEach((to, from) => {
	window.scrollTo(0, 0) // 每次路由改变滚动条都回到顶部
})

export default router